import React, { useState } from 'react';
import './FAQSection.css';

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(0); // Pehla hamesha khula rahega

  const faqData = [
    {
      q: "How quickly can a doctor visit my home?",
      a: "Our doctors typically arrive within 1-2 hours of booking, depending on your location and doctor availability. You can track their arrival in real-time through our app."
    },
    {
      q: "Are your doctors certified and verified?",
      a: "Yes, all our doctors are thoroughly verified with proper medical licenses, degrees, and background checks. We maintain high standards for healthcare professionals."
    },
    {
      q: "What areas do you serve?",
      a: "We currently serve major cities across India and are expanding rapidly. Check our app for availability in your specific location."
    },
    {
      q: "Can I book appointments for family members?",
      a: "Absolutely! You can book doctor home visits for any family member through our app or portal. We specialize in family healthcare services."
    }
  ];

  return (
    <section className="faq-permanent-section" id="faq">
      <div className="faq-wrapper">
        
        <div className="faq-header-static">
          <span className="badge">Support</span>
          <h2>Frequently Asked <span>Questions</span></h2>
          <div className="line-gradient"></div>
        </div>

        <div className="faq-grid-static">
          {faqData.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-card-static ${activeIndex === index ? 'is-active' : ''}`}
              onClick={() => setActiveIndex(activeIndex === index ? null : index)}
            >
              <div className="faq-card-head">
                <div className="faq-info">
                  <span className="faq-num">0{index + 1}</span>
                  <h3>{faq.q}</h3>
                </div>
                <div className="faq-plus-icon"></div>
              </div>
              
              <div className="faq-card-body">
                <div className="faq-answer-inner">
                  <p>{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FAQSection;